var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3247_11553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.79 21L3 11.21V13.21C3 13.74 3.21 14.25 3.59 14.62L11.38 22.41C12.16 23.19 13.43 23.19 14.21 22.41L20.42 16.2C21.2 15.42 21.2 14.15 20.42 13.37L12.79 21Z",
    fill: "#A984F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 17.41C12.16 18.19 13.43 18.19 14.21 17.41L20.42 11.2C21.2 10.42 21.2 9.15 20.42 8.37L12.63 0.58C12.2501 0.209302 11.7408 0.00124533 11.21 0L5 0C3.9 0 3 0.9 3 2V8.21C3 8.74 3.21 9.25 3.59 9.62L11.38 17.41ZM7.25 3C7.58152 3 7.89946 3.1317 8.13388 3.36612C8.3683 3.60054 8.5 3.91848 8.5 4.25C8.5 4.58152 8.3683 4.89946 8.13388 5.13388C7.89946 5.3683 7.58152 5.5 7.25 5.5C6.91848 5.5 6.60054 5.3683 6.36612 5.13388C6.1317 4.89946 6 4.58152 6 4.25C6 3.91848 6.1317 3.60054 6.36612 3.36612C6.60054 3.1317 6.91848 3 7.25 3Z",
    fill: "#A984F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3247_11553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.6c2ac936c6e3a50474749b00a9b6e67b.svg";
export { ForwardRef as ReactComponent };